





















import { mapState } from "vuex";

window.onload = () => {
  localStorage.removeItem("recentlyVisitedReport");
};

export default {
  data() {
    return {
      selectedRoute: null,
    };
  },
  methods: {
    handleValueChange(v) {
      if (!v) return;
      this.$router.push(`/reports/${v}`);
    },
  },
  mounted() {
    const selectedRoute = this.$route.fullPath.split("/reports/")[1];
    this.selectedRoute = selectedRoute;
  },
  computed: {
    ...mapState("misc", ["allValidMenuItem"]),
    reportSelector() {
      const allMenu = this.allValidMenuItem.find(
        (x: any) => x?.name === "Reports"
      );
      return allMenu?.children ?? [];
    },
  },
};
